import axios from '@/libs/api.request'
import config from '@/config'

// 日志平台基础URL
const baseLogUrl = config.baseLogUrl
const logBaseUrl = baseLogUrl + '/api/log/'

export const queryLogs = (params) => {
  return axios.request({
    url: logBaseUrl + 'query',
    params: params,
    method: 'get'
  })
}

export const queryHosts = (params) => {
  return axios.request({
    url: logBaseUrl + 'query_hosts',
    params: params,
    method: 'get'
  })
}

export const queryLogCategorys = (params) => {
  return axios.request({
    url: logBaseUrl + 'query_categorys',
    params: params,
    method: 'get'
  })
}

export const queryLogPaths = (params) => {
  return axios.request({
    url: logBaseUrl + 'query_paths',
    params: params,
    method: 'get'
  })
}

export const queryHostPathCount = (params) => {
  return axios.request({
    url: logBaseUrl + 'query_path_count',
    params: params,
    method: 'get'
  })
}

export const queryDateCount = (params) => {
  return axios.request({
    url: logBaseUrl + 'query_date_count',
    params: params,
    method: 'get'
  })
}

export const queryHostContentCount = (params) => {
  return axios.request({
    url: logBaseUrl + 'query_content_count',
    params: params,
    method: 'get'
  })
}

export const analyzeLogs = (params) => {
  return axios.request({
    url: logBaseUrl + 'analyze',
    params: params,
    method: 'get'
  })
}

export const reAnalyzeLogs = (params) => {
  return axios.request({
    url: logBaseUrl + 're_analyze',
    params: params,
    method: 'get'
  })
}

export const analyzeList = (params) => {
  return axios.request({
    url: logBaseUrl + 'analyze_list',
    params: params,
    method: 'get'
  })
}

export const getAllIndex = () => {
  return axios.request({
    url: logBaseUrl + 'query_all_index',
    method: 'get'
  })
}

export const createIndex = (data) => {
  return axios.request({
    url: logBaseUrl + 'create_index',
    data: data,
    method: 'post'
  })
}

export const deleteIndex = (data) => {
  return axios.request({
    url: logBaseUrl + 'delete_index',
    data: data,
    method: 'delete'
  })
}

// 插件Filebeat管理
export const installAgent = (data) => {
  return axios.request({
    url: logBaseUrl + 'agent_install',
    data: data,
    method: 'post'
  })
}

export const unInstallAgent = (data) => {
  return axios.request({
    url: logBaseUrl + 'agent_uninstall',
    data: data,
    method: 'post'
  })
}

export const configAgent = (data) => {
  return axios.request({
    url: logBaseUrl + 'agent_config',
    data: data,
    method: 'post'
  })
}

// Agent 读取配置文件
export const getHostLogConfig = (params) => {
  return axios.request({
    url: logBaseUrl + 'read_config',
    params: params,
    method: 'get'
  })
}

// 获取 设置了 日志采集规则的 server 列表
export const getConfigServer = (params) => {
  return axios.request({
    url: logBaseUrl + 'server_config_list/',
    params: params,
    method: 'get'
  })
}

// Agent 操作日志列表
export const getAgentLogs = (params) => {
  return axios.request({
    url: logBaseUrl + 'agent_log/',
    params: params,
    method: 'get'
  })
}

// 查询条件历史
export const getHistoryConditions = (params) => {
  return axios.request({
    url: logBaseUrl + 'condition/',
    params: params,
    method: 'get'
  })
}

// 保存更新查询条件
export const saveConditon = (data) => {
  return axios.request({
    url: logBaseUrl + 'condition/',
    data: data,
    method: 'post'
  })
}
